import { render, staticRenderFns } from "./UiHeading.ts.vue?vue&type=template&id=b9b68fb0&scoped=true"
import script from "./UiHeading.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiHeading.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UiHeading.ts.vue?vue&type=style&index=0&id=b9b68fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b68fb0",
  null
  
)

export default component.exports